// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-answer img {\n  width: 300px;\n  height: auto;\n  margin-bottom: 1em;\n  cursor: pointer;\n}\n@media print {\n  .image-answer img {\n    width: 200px;\n  }\n}\n.image-answer .image-answer-note {\n  font-style: italic;\n}\n.modal-header {\n  text-align: right;\n  border-bottom: 0 !important;\n}\n.modal-header button.close {\n  margin-top: -15px;\n  font-size: 24px;\n  font-weight: bold;\n  color: #f00;\n}\n", ""]);
// Exports
module.exports = exports;
